import React from 'react';
import ReactDOM from 'react-dom';
import Index from './Router';

ReactDOM.render(<Index />, document.querySelector('#root'));



// WEBPACK FOOTER //
// ./src/index.js